webpackJsonp([1],{

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      title: ''
    };
  },

  methods: {
    logout: function logout() {
      localStorage.clear();
      this.$router.push('/login');
    }
  },
  computed: {
    isLogin: function isLogin() {
      if (localStorage.getItem('nama_toko')) {
        this.title = ' - ' + localStorage.getItem('nama_toko').toUpperCase();
        return localStorage.getItem('id_toko');
      } else {
        return 0;
      }
    }
  },
  beforeMount: function beforeMount() {
    if (!localStorage.getItem('id_toko') && this.$route.path !== '/login') {
      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PieChart__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_exceljs__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_exceljs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_exceljs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_2__components_PieChart__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      loadingOutlet: true,
      summary: {},
      outlet: [],
      outletHeader: [],
      newOutlet: [],
      filter: {
        tglAwal: null,
        tglAkhir: null
      },
      btnDownload: {
        text: 'Download Excel',
        disable: false
      }
    };
  },

  methods: {
    cari: function cari() {
      this.outlet = [];
      this.outletHeader = [];
      this.fetchSummary();
      this.fetchOutlet();
    },
    fetchSummary: function fetchSummary() {
      var self = this;

      var param = {
        id_toko: localStorage.getItem('id_toko')
      };

      if (self.filter.tglAwal && self.filter.tglAkhir) {
        param.tgl_awal = self.filter.tglAwal;
        param.tgl_akhir = self.filter.tglAkhir;
      }

      self.summary.totalBill = '';
      self.summary.totalOrder = '';
      self.summary.totalItem = '';
      self.summary.totalCustomer = '';

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('http://dashboard.restoku.id/welcome/summaryOrder', { params: param }).then(function (r) {
        self.summary.totalBill = r.data.total_bill;
        self.summary.totalOrder = r.data.total_order;
        self.summary.totalItem = r.data.total_item;
        self.summary.totalCustomer = r.data.total_customer;
      });
    },
    fetchOutlet: function fetchOutlet() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('http://dashboard.restoku.id/welcome/getOutlet?id_toko=' + localStorage.getItem('id_toko')).then(function (r) {
        _this.loading = false;

        _this.outletHeader = r.data;
        // this.renderCard(0, r.data)
        _this.fetchSummaryOutlet(0, r.data);
      });
    },
    renderCard: function renderCard(index, item) {
      var self = this;
      item[index].summary = {};
      self.outlet.push(item[index]);

      if (index <= item.length - 2) {
        setTimeout(function () {
          var newIndex = index + 1;
          self.renderCard(newIndex, item);
          self.fetchSummaryOutlet(newIndex, item[newIndex]);
        }, 500);
      }
    },
    fetchSummaryOutlet: function fetchSummaryOutlet(index, item) {
      var self = this;
      if (index <= item.length - 1) {
        var params = {
          id_toko: item[index].id
        };

        if (self.filter.tglAwal && self.filter.tglAkhir) {
          params.tgl_awal = self.filter.tglAwal;
          params.tgl_akhir = self.filter.tglAkhir;
        }

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('http://dashboard.restoku.id/welcome/getSummaryPerToko', { params: params }).then(function (r) {
          var top8 = [];
          r.data.top_8.forEach(function (item) {
            top8.push({
              id_menu: item.id,
              jumlah: item.jumlah,
              menu: item.nama
            });
          });

          item[index].summary = {
            id_toko: item.id,
            total: r.data ? r.data.omzet.total : '0',
            itemTerjual: r.data ? r.data.item_terjual.total : '0',
            top8: top8,
            tipePembayaran: r.data.tipe_pembayaran
          };

          self.outlet.push(item[index]);

          setTimeout(function () {
            var newIndex = index + 1;
            self.fetchSummaryOutlet(newIndex, item);
          }, 500);
        });
      } else {
        this.loadingOutlet = false;
      }
    },
    excel: function excel() {
      var _this2 = this;

      var self = this;
      var params = {
        id_toko: localStorage.getItem('id_toko')
      };

      if (self.filter.tglAwal && self.filter.tglAkhir) {
        params.tgl_awal = self.filter.tglAwal;
        params.tgl_akhir = self.filter.tglAkhir;
      }

      self.btnDownload.text = 'Processing...';
      self.btnDownload.disable = true;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('http://dashboard.restoku.id/welcome/generateReportExcel', { params: params }).then(function (r) {
        var workbook = new __WEBPACK_IMPORTED_MODULE_3_exceljs___default.a.Workbook();
        var worksheet = workbook.addWorksheet('LAPORAN');
        var sheet2 = workbook.addWorksheet('ITEM PENJUALAN');

        var columns = [{ header: 'Tanggal', key: 'tanggal' }];

        _this2.outletHeader.forEach(function (item) {
          columns.push({
            header: item.nama, key: 'toko_' + item.id
          });
        });
        worksheet.columns = columns;

        var tgl = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(r.data);
        tgl.forEach(function (item) {
          var row = {
            tanggal: item
          };

          _this2.outletHeader.forEach(function (outlet) {
            if (r.data[item][outlet.id]) {
              row['toko_' + outlet.id] = parseInt(r.data[item][outlet.id].grand_total);
            } else {
              row['toko_' + outlet.id] = 0;
            }
          });

          worksheet.addRow(row);
        });

        sheet2.columns = [{ header: 'Outlet', key: 'outlet' }, { header: 'Tanggal', key: 'tanggal' }, { header: 'Menu', key: 'menu' }, { header: 'Harga', key: 'harga' }, { header: 'Jumlah', key: 'jumlah' }, { header: 'Total', key: 'total' }];

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('http://dashboard.restoku.id/welcome/generateItemPenjualanExcel', { params: params }).then(function (r) {
          self.btnDownload.text = 'Download Excel';
          self.btnDownload.disable = false;

          r.data.forEach(function (item) {
            sheet2.addRow({
              outlet: item.outlet,
              tanggal: item.tanggal,
              menu: item.menu,
              harga: item.harga_menu,
              jumlah: item.jumlah,
              total: parseInt(item.harga_menu) * parseInt(item.jumlah)
            });
          });

          workbook.xlsx.writeBuffer('export.xlsx').then(function (buffer) {
            var blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            Object(__WEBPACK_IMPORTED_MODULE_4_file_saver__["saveAs"])(blob, 'SUMMARY PENJUALAN.xlsx');
          });
        });
      });
    }
  },
  mounted: function mounted() {
    this.fetchSummary();
    this.fetchOutlet();
  }
});

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      login: {},
      btnDisabled: false
    };
  },

  methods: {
    auth: function auth() {
      var _this = this;

      this.btnDisabled = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('http://dashboard.restoku.id/login/authVue', this.login).then(function (r) {
        if (r.data.failed) {
          alert('Login Gagal');
          _this.btnDisabled = false;
        } else {
          localStorage.setItem('id_toko', r.data.id);
          localStorage.setItem('nama_toko', r.data.nama);
          _this.$router.push('/');
        }
      }).catch(function (e) {
        _this.btnDisabled = false;
      });
    }
  }
});

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(168);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('numeric', function (value) {
  if (value || value === 0) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
});

window.config = {
  apiUrl: 'http://157.230.43.193/restoku-api/api'
  /* eslint-disable no-new */
};new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fcaf229_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(167);
function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fcaf229_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 165:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('span',[_vm._v("Restoku Dashboard "+_vm._s(_vm.title))]),_vm._v(" "),(_vm.isLogin)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.logout}},[_c('img',{attrs:{"src":"https://img.icons8.com/windows/32/FFFFFF/logout-rounded.png"}})]):_vm._e()]),_vm._v(" "),_c('main',[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(226);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Login__["a" /* default */]
  }]
}));

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21cc8849_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(225);
function injectStyle (ssrContext) {
  __webpack_require__(171)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21cc8849"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21cc8849_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 171:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieChart_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 216:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 27,
	"./af.js": 27,
	"./ar": 28,
	"./ar-dz": 29,
	"./ar-dz.js": 29,
	"./ar-kw": 30,
	"./ar-kw.js": 30,
	"./ar-ly": 31,
	"./ar-ly.js": 31,
	"./ar-ma": 32,
	"./ar-ma.js": 32,
	"./ar-sa": 33,
	"./ar-sa.js": 33,
	"./ar-tn": 34,
	"./ar-tn.js": 34,
	"./ar.js": 28,
	"./az": 35,
	"./az.js": 35,
	"./be": 36,
	"./be.js": 36,
	"./bg": 37,
	"./bg.js": 37,
	"./bm": 38,
	"./bm.js": 38,
	"./bn": 39,
	"./bn.js": 39,
	"./bo": 40,
	"./bo.js": 40,
	"./br": 41,
	"./br.js": 41,
	"./bs": 42,
	"./bs.js": 42,
	"./ca": 43,
	"./ca.js": 43,
	"./cs": 44,
	"./cs.js": 44,
	"./cv": 45,
	"./cv.js": 45,
	"./cy": 46,
	"./cy.js": 46,
	"./da": 47,
	"./da.js": 47,
	"./de": 48,
	"./de-at": 49,
	"./de-at.js": 49,
	"./de-ch": 50,
	"./de-ch.js": 50,
	"./de.js": 48,
	"./dv": 51,
	"./dv.js": 51,
	"./el": 52,
	"./el.js": 52,
	"./en-au": 53,
	"./en-au.js": 53,
	"./en-ca": 54,
	"./en-ca.js": 54,
	"./en-gb": 55,
	"./en-gb.js": 55,
	"./en-ie": 56,
	"./en-ie.js": 56,
	"./en-il": 57,
	"./en-il.js": 57,
	"./en-in": 58,
	"./en-in.js": 58,
	"./en-nz": 59,
	"./en-nz.js": 59,
	"./en-sg": 60,
	"./en-sg.js": 60,
	"./eo": 61,
	"./eo.js": 61,
	"./es": 62,
	"./es-do": 63,
	"./es-do.js": 63,
	"./es-us": 64,
	"./es-us.js": 64,
	"./es.js": 62,
	"./et": 65,
	"./et.js": 65,
	"./eu": 66,
	"./eu.js": 66,
	"./fa": 67,
	"./fa.js": 67,
	"./fi": 68,
	"./fi.js": 68,
	"./fil": 69,
	"./fil.js": 69,
	"./fo": 70,
	"./fo.js": 70,
	"./fr": 71,
	"./fr-ca": 72,
	"./fr-ca.js": 72,
	"./fr-ch": 73,
	"./fr-ch.js": 73,
	"./fr.js": 71,
	"./fy": 74,
	"./fy.js": 74,
	"./ga": 75,
	"./ga.js": 75,
	"./gd": 76,
	"./gd.js": 76,
	"./gl": 77,
	"./gl.js": 77,
	"./gom-deva": 78,
	"./gom-deva.js": 78,
	"./gom-latn": 79,
	"./gom-latn.js": 79,
	"./gu": 80,
	"./gu.js": 80,
	"./he": 81,
	"./he.js": 81,
	"./hi": 82,
	"./hi.js": 82,
	"./hr": 83,
	"./hr.js": 83,
	"./hu": 84,
	"./hu.js": 84,
	"./hy-am": 85,
	"./hy-am.js": 85,
	"./id": 86,
	"./id.js": 86,
	"./is": 87,
	"./is.js": 87,
	"./it": 88,
	"./it-ch": 89,
	"./it-ch.js": 89,
	"./it.js": 88,
	"./ja": 90,
	"./ja.js": 90,
	"./jv": 91,
	"./jv.js": 91,
	"./ka": 92,
	"./ka.js": 92,
	"./kk": 93,
	"./kk.js": 93,
	"./km": 94,
	"./km.js": 94,
	"./kn": 95,
	"./kn.js": 95,
	"./ko": 96,
	"./ko.js": 96,
	"./ku": 97,
	"./ku.js": 97,
	"./ky": 98,
	"./ky.js": 98,
	"./lb": 99,
	"./lb.js": 99,
	"./lo": 100,
	"./lo.js": 100,
	"./lt": 101,
	"./lt.js": 101,
	"./lv": 102,
	"./lv.js": 102,
	"./me": 103,
	"./me.js": 103,
	"./mi": 104,
	"./mi.js": 104,
	"./mk": 105,
	"./mk.js": 105,
	"./ml": 106,
	"./ml.js": 106,
	"./mn": 107,
	"./mn.js": 107,
	"./mr": 108,
	"./mr.js": 108,
	"./ms": 109,
	"./ms-my": 110,
	"./ms-my.js": 110,
	"./ms.js": 109,
	"./mt": 111,
	"./mt.js": 111,
	"./my": 112,
	"./my.js": 112,
	"./nb": 113,
	"./nb.js": 113,
	"./ne": 114,
	"./ne.js": 114,
	"./nl": 115,
	"./nl-be": 116,
	"./nl-be.js": 116,
	"./nl.js": 115,
	"./nn": 117,
	"./nn.js": 117,
	"./oc-lnc": 118,
	"./oc-lnc.js": 118,
	"./pa-in": 119,
	"./pa-in.js": 119,
	"./pl": 120,
	"./pl.js": 120,
	"./pt": 121,
	"./pt-br": 122,
	"./pt-br.js": 122,
	"./pt.js": 121,
	"./ro": 123,
	"./ro.js": 123,
	"./ru": 124,
	"./ru.js": 124,
	"./sd": 125,
	"./sd.js": 125,
	"./se": 126,
	"./se.js": 126,
	"./si": 127,
	"./si.js": 127,
	"./sk": 128,
	"./sk.js": 128,
	"./sl": 129,
	"./sl.js": 129,
	"./sq": 130,
	"./sq.js": 130,
	"./sr": 131,
	"./sr-cyrl": 132,
	"./sr-cyrl.js": 132,
	"./sr.js": 131,
	"./ss": 133,
	"./ss.js": 133,
	"./sv": 134,
	"./sv.js": 134,
	"./sw": 135,
	"./sw.js": 135,
	"./ta": 136,
	"./ta.js": 136,
	"./te": 137,
	"./te.js": 137,
	"./tet": 138,
	"./tet.js": 138,
	"./tg": 139,
	"./tg.js": 139,
	"./th": 140,
	"./th.js": 140,
	"./tk": 141,
	"./tk.js": 141,
	"./tl-ph": 142,
	"./tl-ph.js": 142,
	"./tlh": 143,
	"./tlh.js": 143,
	"./tr": 144,
	"./tr.js": 144,
	"./tzl": 145,
	"./tzl.js": 145,
	"./tzm": 146,
	"./tzm-latn": 147,
	"./tzm-latn.js": 147,
	"./tzm.js": 146,
	"./ug-cn": 148,
	"./ug-cn.js": 148,
	"./uk": 149,
	"./uk.js": 149,
	"./ur": 150,
	"./ur.js": 150,
	"./uz": 151,
	"./uz-latn": 152,
	"./uz-latn.js": 152,
	"./uz.js": 151,
	"./vi": 153,
	"./vi.js": 153,
	"./x-pseudo": 154,
	"./x-pseudo.js": 154,
	"./yo": 155,
	"./yo.js": 155,
	"./zh-cn": 156,
	"./zh-cn.js": 156,
	"./zh-hk": 157,
	"./zh-hk.js": 157,
	"./zh-mo": 158,
	"./zh-mo.js": 158,
	"./zh-tw": 159,
	"./zh-tw.js": 159
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.cari($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.tglAwal),expression:"filter.tglAwal"}],attrs:{"type":"date"},domProps:{"value":(_vm.filter.tglAwal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filter, "tglAwal", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.tglAkhir),expression:"filter.tglAkhir"}],attrs:{"type":"date"},domProps:{"value":(_vm.filter.tglAkhir)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filter, "tglAkhir", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"submit","value":"Filter"}})]),_vm._v("\n       \n      "),_c('button',{attrs:{"type":"button","disabled":_vm.btnDownload.disable},on:{"click":_vm.excel}},[_vm._v(_vm._s(_vm.btnDownload.text))])])]),_vm._v(" "),_c('div',{staticClass:"grid-3 summary"},[_c('div',{staticClass:"card"},[_c('h1',[_vm._v(_vm._s(_vm._f("numeric")(_vm.summary.totalBill)))]),_vm._v(" "),_c('h3',[_vm._v("Total Bill")])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('h1',[_vm._v(_vm._s(_vm._f("numeric")(_vm.summary.totalOrder)))]),_vm._v(" "),_c('h3',[_vm._v("Total Omzet")])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('h1',[_vm._v(_vm._s(_vm._f("numeric")(_vm.summary.totalItem)))]),_vm._v(" "),_c('h3',[_vm._v("Total Item Terjual")])])]),_vm._v(" "),_c('h3',[_vm._v("Transaksi per Outlet "),(_vm.loadingOutlet)?_c('span',[_vm._v("("+_vm._s(_vm.outlet.length)+" dari "+_vm._s(_vm.outletHeader.length)+")")]):_vm._e()]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"if-loading"},[_c('div',{staticClass:"loader"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"grid-3 grid-border gap-15"},_vm._l((_vm.outlet),function(item){return _c('div',{key:item.id,staticClass:"card"},[_c('div',[_c('h3',[_vm._v(_vm._s(item.nama))]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(!item.summary.total)?_c('div',{staticClass:"if-loading"},[_c('div',{staticClass:"loader"})]):_vm._e(),_vm._v(" "),(item.summary.total)?_c('div',[_c('div',{staticClass:"grid-2"},[_c('div',{staticClass:"detail"},[_c('span',[_vm._v("Omzet")]),_vm._v(" "),_c('label',[_vm._v("Rp "+_vm._s(_vm._f("numeric")(item.summary.total)))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('span',[_vm._v("Item terjual")]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm._f("numeric")(item.summary.itemTerjual)))])])]),_vm._v(" "),_c('div',{staticClass:"item-terjual"},[_c('span',[_vm._v("Item Terjual (Top 8)")]),_vm._v(" "),_c('div',{staticClass:"grid-2 gap-15"},[_c('div',[_c('ul',_vm._l((item.summary.top8),function(mn){return _c('li',[_c('div',[_vm._v(_vm._s(mn.menu))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(mn.jumlah))])])}),0)]),_vm._v(" "),_c('div',[_c('PieChart',{staticStyle:{"width":"250px"},attrs:{"menu":item.summary.top8}})],1)])]),_vm._v(" "),_c('div',{staticClass:"item-terjual"},[_c('span',[_vm._v("Pembayaran")]),_vm._v(" "),_c('div',{staticClass:"grid-2 gap-15"},[_c('div',[_c('ul',_vm._l((item.summary.tipePembayaran),function(tipe){return _c('li',[_c('div',[_vm._v(_vm._s(tipe.tipe_pembayaran))]),_vm._v(" "),_c('span',[_vm._v("Rp "+_vm._s(_vm._f("numeric")(tipe.total)))])])}),0)])])])]):_vm._e()])])])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Ringkasan Transaksi")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dde018e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(228);
function injectStyle (ssrContext) {
  __webpack_require__(227)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dde018e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dde018e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 227:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.auth($event)}}},[_c('h3',[_vm._v("LOGIN")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.email),expression:"login.email"}],attrs:{"type":"email"},domProps:{"value":(_vm.login.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "email", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.password),expression:"login.password"}],attrs:{"type":"password"},domProps:{"value":(_vm.login.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "password", $event.target.value)}}}),_vm._v(" "),_c('button',{attrs:{"type":"submit","disabled":_vm.btnDisabled}},[_vm._v("Login")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(217);
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Pie */],
  props: {
    menu: {
      type: Array
    }
  },
  mounted: function mounted() {
    var chartData = {};
    var options = {
      responsive: true,
      maintainAspectRatio: true,
      legend: {
        display: false
      }
    };

    var menu = [];
    var jumlah = [];
    var color = [];

    this.menu.forEach(function (item) {
      menu.push(item.menu);
      jumlah.push(item.jumlah);
      color.push('#' + (Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0'));
    });

    chartData.labels = menu;
    chartData.datasets = {
      backgroundColor: color,
      data: jumlah
    };

    var cd = {
      labels: menu,
      datasets: [{
        label: 'Data One',
        backgroundColor: color,
        data: jumlah
      }]
    };

    this.renderChart(cd, options);
  }
});

/***/ })

},[161]);


// WEBPACK FOOTER //
// static/js/app.4f8bd7a1b2e84201c34a.js